(() => {
  const root = document.querySelector('[data-ots-editorial-page][data-page-handle="faq"]');
  if (!root) return;

  const content = root.querySelector('.ots-editorial-page__content');
  const toc = root.querySelector('.ots-editorial-page__toc');
  const list = toc?.querySelector('ol');
  if (!content || !toc || !list) return;

  const headings = Array.from(content.querySelectorAll('h1, h2, h3'));
  const findHeading = (word) => headings.find((heading) => heading.textContent.toLowerCase().includes(word));
  const shipping = findHeading('shipping');
  const returns = findHeading('returns');
  if (!shipping && !returns) return;

  const ordering = document.createElement('h2');
  ordering.id = 'ots-faq-ordering';
  ordering.textContent = 'Ordering & support';
  content.prepend(ordering);

  const sections = [[ordering, 'Ordering & support']];
  if (shipping) {
    shipping.id = 'ots-faq-shipping';
    sections.push([shipping, 'Shipping and customs']);
  }
  if (returns) {
    returns.id = 'ots-faq-returns';
    sections.push([returns, 'Returns']);
  }

  for (const [heading, label] of sections) {
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = label;
    item.append(link);
    list.append(item);
  }
  toc.hidden = false;
  root.classList.add('has-toc');
})();
